import {URL_DOCUMENTO_HISTORICO, URL_HISTORICO_TRASLADO, URL_SERVER, URL_VENTA_HISTORICO} from "../../../api/config";
import {
  HISTORICO_AJUSTE,
  HISTORICO_DEVOLUCION_CLIENTE,
  HISTORICO_DEVOLUCION_PROVEEDOR
} from "../../../components/Productos/routes";
import {makeQueryElastic, makeQueryHistorico} from "../../../api/helper";
import {sucursal} from "../../getters";

export default {
  namespaced: true,
  state: {
    ventas: [],
    compras: [],
    ajustes: [],
    devolucion_clientes: [],
    devolucion_proveedores: [],
    guias: []
  },
  mutations: {
    'SET_VENTAS'(state, payload) {

      state.ventas = [...payload.sort((a, b) =>  new Date(b.date) -  new Date(a.date))]
    },
    'SET_COMPRAS'(state, payload) {
      state.compras = [...payload.sort((a, b) =>  new Date(b.created_at) -  new Date(a.created_at))]
    },
    'SET_AJUSTES'(state, payload) {
      state.ajustes = [...payload.sort((a, b) =>  new Date(b.created_at) -  new Date(a.created_at))]
    },
    'SET_DEVOLUCION_CLIENTES'(state, payload) {
      console.log('payload', payload)
      state.devolucion_clientes = [...payload.sort((a, b) =>  new Date(b.fecha_creacion) -  new Date(a.fecha_creacion))]
    },
    'SET_DEVOLUCION_PROVEEDORES'(state, payload) {
      state.devolucion_proveedores = [...payload]
    },
    'SET_GUIAS'(state, payload) {
      state.guias = [...payload.sort((a, b) =>  new Date(b.fecha_creacion) -  new Date(a.fecha_creacion))]
    },
    'ADD_GUIA'(state, payload) {
      state.guias = [...state.guias, payload]
    },
  },
  actions: {
    fetchAll(context, filtro) {
      const { dispatch } = context
      dispatch('fetchVentas', filtro)
      dispatch('fetchCompras', filtro)
      dispatch('fetchDevolucionClientes', filtro)
      dispatch('fetchDevolucionProveedores', filtro)
      dispatch('fetchGuias', filtro)
      dispatch('fetchAjustes', filtro)
    },
    fetchVentas({ commit }, filtro) {
      this._vm.$axios(URL_VENTA_HISTORICO + `/${filtro.productoId}` + makeQueryHistorico(filtro))
        .then(({ data }) => {
          commit('SET_VENTAS', data.items)
        })
    },
    fetchCompras({ commit }, filtro){
      this._vm.$axios(URL_DOCUMENTO_HISTORICO +  makeQueryHistorico(filtro))
        .then(({ data }) => commit('SET_COMPRAS', data.items))
    },
    fetchGuias({ commit }, filtro){
      this._vm.$axios(URL_HISTORICO_TRASLADO + makeQueryHistorico(filtro))
        .then(({ data }) => {
          console.log('data', data)
          data.items.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).forEach(guia => {
            const {glosa, ...resto} = guia
            guia.glosa.filter(lg => lg.productoId === filtro.productoId).forEach(item => {
              commit('ADD_GUIA', {
                ...resto,
                ...item
              })
            })
          })
        })
    },
    fetchAjustes({ commit }, filtro){
      console.log('filtro_ajustes',filtro)
      this._vm.$axios.get(HISTORICO_AJUSTE + makeQueryElastic(filtro))
        .then(({data}) => {
          console.log(data, "ajuste")
          commit('SET_AJUSTES', data.items)
        })
    },
    async fetchDevolucionClientes({ commit }, filtro){
      console.log('filtro', makeQueryHistorico(filtro))
      const {data} = await this._vm.$axios.get(HISTORICO_DEVOLUCION_CLIENTE  + makeQueryHistorico(filtro))

      commit('SET_DEVOLUCIONES_CLIENTES', data.items)
    },
    fetchDevolucionProveedores({ commit }, filtro){
      this._vm.$axios.get(HISTORICO_DEVOLUCION_PROVEEDOR  + makeQueryHistorico(filtro))
        .then(({data}) => commit('SET_DEVOLUCION_PROVEEDORES', data.items))
    },
  },
  getters: {
    ventas: ({ventas}) => ventas,
    compras: ({compras}) => compras,
    ajustes: ({ajustes}) => ajustes,
    devolucion_clientes: ({ devolucion_clientes }) => devolucion_clientes,
    devolucion_proveedores: ({ devolucion_proveedores }) => devolucion_proveedores,
    enviados: ({ guias }) => (sucursal_id) => {
      return guias.filter(g => g.sucursal_id === sucursal_id && g.estado === 'revisado')
    },
    recibidos: ({ guias }) => (sucursal_id) => {
      console.log('guias', guias, sucursal_id)
      return guias.filter(g => g.sucursalDestinoId === sucursal_id && g.estado === 'revisado')

    },
    cantidad_enviados: ({guias}) => (sucursal_id, estado) => {
      return guias.filter(g => g.sucursal_id === sucursal_id && g.estado === estado)
        .reduce((acc, i) => acc += i.cantidad, 0)
    },
    cantidad_recibidos: ({guias}) => (sucursal_id, estado) => {
      return guias.filter(g => g.sucursalDestinoId === sucursal_id && g.estado === estado)
        .reduce((acc, i) => acc += i.cantidad, 0)
    }
  }
}
